export const toggleOfferTableDropdownList = () => {
	const offerTables = $('.offer-table');

	if (offerTables) {
		offerTables.each(function () {
			const that = $(this);
			const dropdownList = that.find('.offer-table-dropdown-list');
			const dropdownListButton = dropdownList.find('.dropdown-list-button');

			dropdownListButton.off().click(function () {
				const dropdownListContent = $(this).parent().find('.dropdown-list-content');
				const dropdownListButtonText = $(this).find('button');
				const hiddenContentButtonText = $(this).attr('data-hidden-content-text');
				const shownContentButtonText = $(this).attr('data-show-content-text');

				dropdownListContent.slideToggle(250);
				$(this).toggleClass('rotate-icon');

				if (dropdownListButtonText.text() === hiddenContentButtonText) {
					dropdownListButtonText.fadeOut(125, function () {
						$(this).text(shownContentButtonText).fadeIn(125);
					});
				} else {
					dropdownListButtonText.fadeOut(125, function () {
						$(this).text(hiddenContentButtonText).fadeIn(125);
					});
				}
			});
		});
	}
};
